<template>
  <div>
    <b-modal :id="modal" :size="size" :title="title" lazy>
      <slot></slot>
      <template #modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button
          size="sm"
          variant="primary"
          @click="submit"
          :disabled="loading || emptyForm"
        >
          <span v-if="!loading"><i class="fas fa-save"></i> Salvar</span>
          <div v-else>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <span class="sr-only">Processando...</span>
          </div></b-button
        >
        <b-button size="sm" variant="secondary" @click="cancel()">
          Fechar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>


<script>
import { mapState } from "vuex";

export default {
  props: {
    size: { default: "md" },
    title: { default: "" },
    modal: { default: "" },
    route: { default: "" },
  },
  data() {
    return {
      emptyForm: true,
      loading: false,
    };
  },
  computed: mapState({
    forms: (state) => state.modal.forms,

    checkForm(state) {
      const index = state.modal.forms.findIndex(
        (form) => form.name === this.modal
      );

      if (index >= 0) {
        const total = Object.keys(this.forms[index].data).length;

        let count = 0;
        for (let [index, item] of Object.entries(this.forms[index].data)) {
          if (item.length === 0) {
            count++;
          }
        }

        if (count === total) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
  }),
  watch: {
    checkForm: function (newValue, oldValue) {
      if (this.checkForm) {
        this.emptyForm = true;
      } else {
        this.emptyForm = false;
      }
    },
  },
  methods: {
    setFormData(route, form) {
      this.route = route;
      this.formData = form;
    },
    async submit() {

      

      const form = this.forms.find((form) => form.name === this.modal);

      if (form.data) {
        this.loading = true;

        const result = await this.$api.post(this.route, form.data);

        if (result.data.success) {
          this.$bvModal.hide(this.modal);
          if (result.data.mutation) {
            this.$store.commit(
              result.data.mutation.path,
              result.data.mutation.params
            );
          }
          if (result.data.action) {
            this.$store.dispatch(
              result.data.action.path,
              result.data.action.params
            );
          }
        }
        this.loading = false;
      }
    },
  },
};
</script>